"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Composite = exports.useComposite = exports.CompositeContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var Matter = _interopRequireWildcard(require("matter-js"));

var _hooks = require("../hooks");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var eventNames = ['beforeAdd', 'afterAdd', 'beforeRemove', 'afterRemove'];
var CompositeContext = (0, _react.createContext)(undefined);
exports.CompositeContext = CompositeContext;
CompositeContext.displayName = 'Composite';

var useComposite = function useComposite() {
  return (0, _react.useContext)(CompositeContext);
};

exports.useComposite = useComposite;

var Composite = function Composite(_ref) {
  var children = _ref.children,
      events = _ref.events,
      definition = _objectWithoutProperties(_ref, ["children", "events"]);

  var parent = useComposite();
  var composite = (0, _hooks.useCloseable)(function () {
    var composite = Matter.Composite.create(definition);
    Matter.Composite.add(parent, composite);
    return composite;
  }, function (composite) {
    return Matter.Composite.remove(parent, composite);
  });
  eventNames.forEach(function (name) {
    return (0, _react.useEffect)(function () {
      var callback = events[name];
      if (callback == null) return;
      Matter.Events.on(composite, name, callback);
      return function () {
        return Matter.Events.off(composite, name, callback);
      };
    }, [events[name]]);
  });
  return _react.default.createElement(CompositeContext.Provider, {
    value: composite
  }, children);
};

exports.Composite = Composite;

Composite.useEvent = function (name, callback) {
  var composite = useComposite();
  (0, _react.useEffect)(function () {
    Matter.Events.on(composite, name, callback);
    return function () {
      return Matter.Events.off(composite, name, callback);
    };
  }, [composite]);
};